<div class="country">
  <div class="country__name">
    {{ ((noc | countryName) | async)?.CShort }}
  </div>
  <lib-country-flag [id]="noc"></lib-country-flag>
</div>
